export default {
  enums: [
    { id: 'PRODUCTION' },
    { id: 'REMAINS' },
    { id: 'IMPORT' },
    { id: 'CROSSBORDER', },
    { id: 'REMARK', },
  ]
};